import * as z from "zod";

export const getTriggerInheritedDiscount = {
  name: "getTriggerInheritedDiscount" as const,
  input: z.object({ triggerKey: z.string() }),
  output: z.object({
    /**
     * When a matching, enabled automation on the same trigger has a discount
     * embedded in one of its message templates, the runtime uses that discount
     * (see the marketing-agent coordinator's `forceDiscount` path). The UI
     * mirrors this by surfacing the resolved discount here so merchants can
     * see what will actually be offered without also letting them override it
     * on the trigger. `null` means no inherited discount — the merchant's own
     * trigger/brand config applies.
     */
    inherited: z
      .object({
        automationId: z.string(),
        automationName: z.string(),
        discountId: z.string(),
      })
      .nullable(),
  }),
};
